import image1 from './sari (1).jpeg';
import image2 from './sari (2).jpeg';
import image3 from './sari (3).jpeg';
import image4 from './sari (4).jpeg';
import image5 from './sari (5).jpeg';
import image6 from './sari (6).jpeg';
import image7 from './sari (7).jpeg';
import image8 from './sari (8).jpeg';

const swarnachoriLink = 'https://www.facebook.com/100583738717343/posts/116735073768876/?app=fbl';
const bishnupuriLink = 'https://www.facebook.com/100583738717343/posts/116735840435466/?app=fbl';
const products = [
  { id: 0, path: image1, link: swarnachoriLink, title: "Khadi Sari...",},
  { id: 1, path: image2, link: swarnachoriLink, title: "Blended Bangalore silk#all over kathastich work..",},
  { id: 2, path: image3, link: swarnachoriLink, title: "Silk khadi...",},
  { id: 3, path: image4, link: swarnachoriLink, title: "Soft dhakai jamdani...",},
  { id: 4, path: image5, link: swarnachoriLink, title: "Swarnachori saree",},
  { id: 5, path: image6, link: swarnachoriLink, title: "Swarnachori saree",},
  { id: 6, path: image7, link: bishnupuriLink, title: "Block printed bishnupuri silk",},
  { id: 7, path: image8, link: bishnupuriLink, title: "Block printed bishnupuri silk",},
]

export {products};